$(document).on('click', '.showroom-dropdown', function(){
  $(this).find('ul').slideToggle('fast');
})
$(document).on('click', '.showroom-dropdown ul li', function(){
  var Class = $(this).data('location')
  var Text = $(this).text();
  $('.showroom-dropdown ul li').removeClass('selected')
  $(this).addClass('selected')
  $(this).closest('.showroom-dropdown').find('.selected-option').text(Text);
  $('.showroom-content').hide();
  $('.showroom-content').each(function(){
    var showroom = $(this)
    if(showroom.hasClass(Class)){
      showroom.fadeIn();
    }
  })
});

$(document).mouseup(function(e) {
  var container = $(".showroom-dropdown");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    container.find('ul').slideUp('fast');
  }
});



$(document).on('load', function(){
  // Reset Data when Popup is closed
  Fancybox.bind("[data-fancybox]", {
    on: {
      destroy: (fancybox) => {
        $('.selected-option').text('Location');
        $('.showroom-content').hide();
      },
    },
    dragToClose: false   
  });
})

$(document).on('click', 'a.virtualtour', function(){
  setTimeout(function () {
    $('.selected-option').text('Virtual Tour');
    $('.virtual.showroom-content').fadeIn();
  }, 500);
});

$(document).on('click', 'a.newyork', function(){
  setTimeout(function () {
    $('.selected-option').text('New York City (Showroom)');
    $('.newyork.showroom-content').fadeIn();
  }, 500);
});

$(document).on('click', 'a.toronto', function(){
  setTimeout(function () {
    $('.selected-option').text('Toronto (Showroom)');
    $('.toronto.showroom-content').fadeIn();
  }, 500);
});      

$(document).on('click', 'a.chicago', function(){
  setTimeout(function () {
    $('.selected-option').text('Chicago (Partner)');
    $('.chicago.showroom-content').fadeIn();
  }, 500);
});      

$(document).on('click', '.template-page-showrooms-list .section-feature-box .c-iwt-btn[data-calendly="true"]', function(e){
  e.preventDefault();
  $('html, body').animate({
    scrollTop: $("#calendly-inline-widget").offset().top - 200
  }, 300); 
});

//AS - currency dropdown
  function updateCurrency(dropdownSuffix) {
    var domainSuffix = document.domain.split('.')[2];
    if (dropdownSuffix != domainSuffix) {
      var newUrl = window.location.href.replace('.' + domainSuffix, '.' + dropdownSuffix)
       window.location.replace(newUrl)
    }
  }


//AS - utility bar save close state per session
function saveCloseBar(){
  var utilityBar = document.querySelector('.utility-bar');

  //if the utility bar has NOT been closed and show it if so
  if(utilityBar){
    if(sessionStorage.getItem('utilityBarClosed') !== 'true') {
      utilityBar.style.display = 'block';
    } else {
      utilityBar.style.display = 'none';
    }
  }
  
  //close button click
  if(document.getElementById('utility-bar-close')){
    document.getElementById('utility-bar-close').addEventListener('click', function() {
      setTimeout(function() {
        utilityBar.style.display = 'none';
      sessionStorage.setItem('utilityBarClosed', 'true');
      }, 1000);
      closeUtilityBar()
    })
  }
}
document.addEventListener('DOMContentLoaded', function() {
  saveCloseBar()
})

//clarity id - AS 07/2024 - start
//get the Clarity User ID
function getClarityUserId() {
  var cookies = document.cookie.split('; ');
  for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].split('=');
      if (cookie[0] === '_clsk' || cookie[0] === '_clck') {
          var fullValue = decodeURIComponent(cookie[1].trim());
          var userId = fullValue.split('|')[0];
          return userId;
      }
  }
  return 'not found';
}

function sendClarityId() {
  let cartData = { updates: {}, attributes: {} };
  const clarityId = getClarityUserId();
  const themeName = Shopify.theme && Shopify.theme.name ? Shopify.theme.name : 'unknown';

  cartData.attributes['clarity_id'] = clarityId;
  cartData.attributes['theme_name'] = themeName;

  $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: cartData,
      dataType: 'json'
  }).fail(function() {
      console.log('Update.js cart error.');
  }).done(function() {
      console.log('Clarity id sent');
  });
}

$(document).ready(function() {
    sendClarityId();
});

document.addEventListener('DOMContentLoaded', function () {

  if (window.innerWidth >= 900) {
      document.querySelectorAll('header .toggle-header__title-bar .cart-wrap').forEach(link => {
          link.addEventListener('contextmenu', function (e) {
              e.preventDefault();
          });
      });
  }

  //toggle visibility of .toggle-header__slide-down-container
  //based on whether #mobile-sticky-atc has the mobile-sticky-atc--grow class
  //only runs on product pages (URL contains "products")
    if (!window.location.href.includes('products')) {
      return;
    }
    
    function updateVisibility() {
      const mobileSticky = document.getElementById('mobile-sticky-atc');
      const toggleHeader = document.querySelector('.toggle-header__slide-down-container');
      
      if (mobileSticky && toggleHeader) {
        if (mobileSticky.classList.contains('mobile-sticky-atc--grow')) {
          toggleHeader.style.display = 'none';
        } else {
          toggleHeader.style.display = '';
        }
      }
    }
    updateVisibility();

    const mobileSticky = document.getElementById('mobile-sticky-atc');
    
    if (mobileSticky) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            updateVisibility();
          }
          });
      });

      observer.observe(mobileSticky, { 
        attributes: true,
        attributeFilter: ['class']
      });
    }

    /*temp breakline for pdp tooltip*/
    if (window.location.href.indexOf('products') !== -1) {
      setTimeout(function() {
        const tooltipElements = document.querySelectorAll('[data-tooltip]');
        
        tooltipElements.forEach(element => {
          const tooltipText = element.getAttribute('data-tooltip');
          
          if (tooltipText.includes('Tier:')) {
            // Prepend the Memorial Day message with a line break
            let formattedText = 'Use code MEMORIALDAY at checkout to save more when you spend more:\n\n' + tooltipText;
            
            // Apply the existing line break logic
            formattedText = formattedText.replace('$350. ', '$350.\n');
            formattedText = formattedText.replace('$750. ', '$750.\n');
            
            element.setAttribute('data-tooltip', formattedText);
          }
        });
        
      }, 4000);
    }

});
